<template>
    <div class="dcl">
        <comparable-diamond-card
            :diamond="selectedDiamond"
            :heading="$t('singleDiamondsConfigurator.comparableDiamonds.currentHeading')"
        />
        <comparable-diamond-card
            v-if="comparableDiamonds.moreCarat"
            :diamond="comparableDiamonds.moreCarat"
            highlight-attribute="carat"
            :heading="$t('singleDiamondsConfigurator.comparableDiamonds.moreCarat')"
            @click="handleSelectDiamond(comparableDiamonds.moreCarat)"
        />
        <comparable-diamond-card
            v-if="comparableDiamonds.betterColor"
            :diamond="comparableDiamonds.betterColor"
            highlight-attribute="color"
            :heading="$t('singleDiamondsConfigurator.comparableDiamonds.betterColor')"
            @click="handleSelectDiamond(comparableDiamonds.betterColor)"
        />
        <comparable-diamond-card
            v-if="comparableDiamonds.higherClarity"
            :diamond="comparableDiamonds.higherClarity"
            highlight-attribute="clarity"
            :heading="$t('singleDiamondsConfigurator.comparableDiamonds.higherClarity')"
            @click="handleSelectDiamond(comparableDiamonds.higherClarity)"
        />
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import useStore from "@/composables/useStore";
import ComparableDiamondCard from "@/components/ComparableDiamondCard.vue";
import {Diamond} from "@/api/Diamond";

export default defineComponent({
    name: "ComparableDiamonds",
    components: {ComparableDiamondCard},
    setup() {
        const store = useStore();

        function handleSelectDiamond(diamond: Diamond) {
            store.actions.setDiamond(diamond);
        }

        return {
            selectedDiamond: store.computed.selectedDiamond,
            comparableDiamonds: store.computed.comparableDiamonds,
            handleSelectDiamond
        };
    }
});
</script>

<style>
.dcl {
    display: flex;
    gap: 1rem;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    margin-top: 1.5rem;
    padding-bottom: 1rem;
}

.dcc {
    flex-shrink: 0;
    min-width: 150px;
    background: #F8F8F8;
    padding: 20px 14px;
    width: 190px;
    cursor: pointer;
}

.dcc__heading {
    width: min-content;
    white-space: nowrap;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #8A8989;
    margin: 0 0 1.25rem;
}

.dcc_image {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.25rem;
    font-size: 14px;
    color: #8A8989;
}

.dcc_image img {
    height: 14px
}

.dcc__properties {
    width: 100%;
}

.dcc__properties dl {
    display: grid;
    grid-template-columns: max-content auto;
    margin: 0;
}

.dcc__properties dt {
    grid-column-start: 1;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #8A8989;
}

.dcc__properties dd {
    grid-column-start: 2;
    margin-left: 0.5rem;
    white-space: nowrap;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
}

.dcc__properties dd.dcc_properties__highlighted {
    font-weight: normal;
    color: #333333;
}

.dcc__properties dd.dcc_properties__highlighted:after {
    content: "★";
    display: inline-block;
    font-size: 10px;
    vertical-align: top;
    margin-left: 0.25rem;
}

.dcc__price {
    margin-top: 1.5rem;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
}
</style>
